import { createPortal } from "react-dom";

type Props = {
    // Portal target — pass the immersive/fullscreen board container so the
    // overlay renders above the board and inside the OS-fullscreen element
    // (issue #197). Falls back to document.body.
    container?: HTMLElement | null;
    children: React.ReactNode;
};

/** Portals a board overlay (edit menus, pickers) into the board container so it
 *  is visible in immersive and native OS fullscreen. */
export default function BoardOverlay({ container, children }: Props) {
    return createPortal(children, container ?? document.body);
}
